import { useMemo } from 'react';

import { LookUp } from '@work4all/models/lib/Classes/LookUp.entity';
import { LookupType } from '@work4all/models/lib/Enums/LookupType.enum';

export interface UseNewLookUpDataProps {
  enabled?: boolean;
  lookupType?: LookupType;
}

export function useNewLookUpData({
  enabled,
  lookupType,
}: UseNewLookUpDataProps): LookUp {
  return useMemo(() => {
    if (!enabled) {
      return {} as LookUp;
    }

    const newLookUpData: LookUp = {
      name: '',
      lookupType: lookupType || null,
    };

    return newLookUpData;
  }, [enabled, lookupType]);
}
